import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CardModule } from 'primeng/card'
import { DividerModule } from 'primeng/divider'
import { InterventionEditModel } from '../../../../core/models/intervention-edit.model'

@Component({
  selector: 'app-intervention-details',
  standalone: true,
  imports: [CommonModule, CardModule, DividerModule],
  templateUrl: './intervention-details.component.html',
  styleUrls: ['./intervention-details.component.scss'],
})
export class InterventionDetailsComponent {
  @Input() intervention!: InterventionEditModel

  get addressFormatted(): string {
    if (!this.intervention?.affair) return 'Adresse non disponible'

    const affair = this.intervention.affair
    const parts = [
      affair.workSiteAddress,
      affair.workSitePostalCode,
      affair.workSiteLocality,
    ].filter(Boolean)

    return parts.join(', ')
  }

  get hasTimeSlot(): boolean {
    return this.intervention?.isTimeSlot === 1
  }

  get timeSlotFormatted(): string {
    if (!this.hasTimeSlot) return 'Pas de créneau horaire'

    return `${this.intervention.startTimeSlot || ''} - ${this.intervention.endTimeSlot || ''}`
  }
}
